// TextToSpeech.js

import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import toWav from 'audiobuffer-to-wav';
import { set } from 'react-hook-form';
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import { useUserAuth } from "../context/UserAuthContext";
import Button from 'react-bootstrap/Button'


let wavBlob = null;

const TextToSpeech = ({ isVisible, onClose, onReceiveData }) => {
  const { userDataLocal } = useUserAuth();
  const [text, setText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isVisibleTTS, setIsVisibleTTS] = React.useState(false);
  const [duration, setDuration] = useState(0);

  //isRecordViewShown is for record or select sample audio view display, default is true: record view always shown first, 
  // but here set it to false so that the text input view is shown first, let the TTS function never be called as the TTS 
  // function is not used in this project (because the TTS function is not free, and can't deploy to the server, so it is not used)
  const [isRecordViewShown, setIsRecordViewShown] = useState(false);
  const [error, setError] = useState(null);
  const [wavBlobOfRecord, setWavBlobOfRecord] = useState(null);
  const [audioBlob, setAudioBlob] = React.useState(null);
  const [isRecordingSample, setIsRecordingSample] = useState(false);
  const [sampleFileName, setSampleFileName] = useState('');
  const [cloneFileName, setCloneFileName] = useState('');
  const [audioUrl, setAudioUrl] = useState('');
  const ttsOutputRef = useRef(null);
  const [isConvertDone, setIsConvertDone] = useState(false);

  useEffect(() => {
    setIsVisibleTTS(true);
    return () => {
      // const deleteSet = 'all';   //'all','smaple','clone'
      // handleClearFileFromserver(deleteSet);
      setIsVisibleTTS(false);
    };
  }, []);

  useEffect(() => {
    setIsVisibleTTS(isVisible);
  }, [isVisible]);

  //2024.05.31 update usage and transcription to parent component
  useEffect(() => {
    if(text !== '' && duration !== 0) {
      let usageSum = Math.round(duration / 60 * 100) / 100;
      if(usageSum < 1) usageSum = 1;
      let inputValue = text;
      // console.log('inputValue:', inputValue);
      // console.log('usageSum:', usageSum);
      onReceiveData(inputValue, usageSum, Date.now(), false);
    }
  }, [duration]);

  useEffect(() => {
    setDuration(0);
    if(text !== '') {
      setIsConvertDone(false);
      setError(null);
    }
  }, [text]);

  const handleTextChange = (event) => {
    setError(null);
    setText(event.target.value);
  };

  const ttsByOpenAI = async () => {
    setIsLoading(true);
    setError(null);
    setDuration(0);
    setCloneFileName('');
    setAudioUrl('');
    try {
      // 注意这里的URL已经更改，指向我们的后端路由
      const response = await axios.post('/api/openai', {
        model: "tts-1",
        voice: "nova",
        input: text,
        format: "mp3",
        speed: 1.0,
      }, {
        responseType: 'blob', // Important to handle the binary audio response correctly
      });

      saveRecording(new Blob([response.data]));
    } catch (error) {
      setIsLoading(false);
      setError('Error converting text to speech. Please try again.');
      console.error('Error converting text to speech:', error);
    }
  };

  //——————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  //2024.06.06 clone audio
  const handleClone = async () => {
    if (text === '') {
      setError('Please enter text to convert to audio.');
      return;
    }

    if(wavBlobOfRecord === null) {
      setError('You did not provide a sound file to clone, Nvoice will automatically generate a default sound audio for you.');
      ttsByOpenAI();
      return;
    }

    setIsLoading(true);
    setError(null);

    if(cloneFileName !== '') {
      const deleteSet = 'clone';   //'all','smaple','clone'
      await handleClearFileFromserver(deleteSet);
    }

    let lancode;
    if (userDataLocal.Language.lan ==='English') lancode = 'en';
    if (userDataLocal.Language.lan ==='Chinese') lancode = 'zh-cn';
    if (userDataLocal.Language.lan ==='Spanish') lancode = 'es';
    if (userDataLocal.Language.lan ==='French') lancode = 'fr';
    if (userDataLocal.Language.lan ==='Japanese') lancode = 'ja';
    if (userDataLocal.Language.lan ==='Korean') lancode = 'ko';
    if (userDataLocal.Language.lan ==='German') lancode = 'de';
    if (userDataLocal.Language.lan ==='Italian') lancode = 'it';
    if (userDataLocal.Language.lan ==='Russian') lancode = 'ru';
    if (userDataLocal.Language.lan ==='Portuguese') lancode = 'pt';
    if (userDataLocal.Language.lan ==='Dutch') lancode = 'nl';
    if (userDataLocal.Language.lan ==='Arabic') lancode = 'ar';
    if (userDataLocal.Language.lan ==='Turkish') lancode = 'tr';
    if (userDataLocal.Language.lan ==='Hindi') lancode = 'hi';
    if (userDataLocal.Language.lan ==='Hungarian') lancode = 'hu';
    if (userDataLocal.Language.lan ==='Czech') lancode = 'cs';
    if (userDataLocal.Language.lan ==='Polish') lancode = 'pl';

    const audioBlob = wavBlobOfRecord;
    const formData = new FormData();
    const preName = 'Sample';
    const uploadSampleFileName = nameSetbyTime(preName) + '.wav';

    // console.log('sampleFileName:', sampleFileName);
    
    if(sampleFileName !== '') {
      formData.append('audioFile', sampleFileName);
    } else {
      formData.append('audioFile', audioBlob, uploadSampleFileName);
      setSampleFileName(uploadSampleFileName);
    }
    
    formData.append('audio_text', text);
    formData.append('lan_code', lancode);
    formData.append('fileName', uploadSampleFileName);
    // http://127.0.0.1:8888
    // https://www.bingoai.net

    axios({
      method: 'post',
      url: 'http://127.0.0.1:8888/api/audio-clone',
      data: formData, 
      responseType: 'blob'
    })
    .then(function (response) {
      if (response.status === 400) {
        // 返回 400 错误给前端
        setError(response.data);
        return 
      }
      // 从响应头中获取 duration 值
      const duration = response.headers['duration'];
      const fileName = response.headers['filename'];
    
      // 创建一个可以在 <audio> 元素中使用的 URL
      const audioUrlfromServer = URL.createObjectURL(new Blob([response.data]));

      saveRecording(new Blob([response.data]));
    
      console.log('Duration:', duration);
      // console.log('File Name:', fileName);
      // console.log('Audio URL:', audioUrlfromServer);
      // console.log('Success:', response);

      ttsOutputRef.current.src = audioUrlfromServer;
      setDuration(duration);

      // console.log('Filename:', filename);
      setCloneFileName(fileName);

      // 保存音频 URL 和文件名，以便稍后下载
      setAudioUrl(audioUrlfromServer);
      setIsLoading(false); 
      setIsConvertDone(true);
    })
    .catch(error => {
      setDuration(0);
      console.error('Error:', error);
      setError('Error cloning audio. Please try again.');
      setIsLoading(false); 
      setIsConvertDone(false);
    });
  }

  const donwloadClick = () => {
    handleDownloadCloneAudioByAI();
    // if(wavBlobOfRecord === null) {
    //   handleDownloadCloneAudioByAI();
    // } else {
    //   handleDownloadCloneAudioByTTS();
    // }
  }

  const handleDownloadCloneAudioByTTS = () => {
    const link = document.createElement('a');
    link.href = audioUrl;
    link.download = cloneFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleDownloadCloneAudioByAI = () => {
    // Create a URL for the blob
    const url = URL.createObjectURL(wavBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = cloneFileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url); // Clean up
  };

  const handleClearFileFromserver = async (deleteSet) => {
    let data;
    if(deleteSet === 'all') {
      data = {
        outputfilename: cloneFileName,
        inputfilename: sampleFileName
      };
    } else if(deleteSet === 'clone') {
      data = {
        outputfilename: cloneFileName
      };
    } else if(deleteSet === 'sample') {
      data = {
        inputfilename: sampleFileName
      };
    }

    axios.post('http://127.0.0.1:8888/api/clear-files', data)
      .then((response) => {
        console.log(response.data);
        if(deleteSet === 'all') {
          setSampleFileName('');
          setCloneFileName('');
          setAudioUrl('');
          if (ttsOutputRef.current) ttsOutputRef.current.src = '';
        } else if(deleteSet === 'clone') {
          setCloneFileName('');
          setAudioUrl('');
          if (ttsOutputRef.current) ttsOutputRef.current.src = '';
        } else if(deleteSet === 'sample') {
          setSampleFileName('');
        }
      })
      .catch((error) => {
        console.error(error);
      });
    }

    

  //——————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  //recording audio 2024.06.07
  const recorderControls = useAudioRecorder(
  {
      noiseSuppression: true,
      echoCancellation: true,
      channelCount: 1,
      sampleRate: 48000,
      sampleSize: 16,
  },
  (err) => console.table(err) // onNotAllowedOrFound  
  );

  const addAudioElement = (blob) => {
      setAudioBlob(blob);
      // console.log('audioBlob:', blob);
      setTimeout(() => {
          saveRecordingWavBlob(blob);
      }, 3);
      const url = URL.createObjectURL(blob);
      // const fileformat = 'wav';
      // const audio = document.createElement(`${nameSetbyTime(fileformat)}`);
      // audio.src = url;
      // audio.controls = true;
      // document.body.appendChild(audio);
  };

  const handleRecordBtnClick = () => {
      if (isRecordingSample) {
          stopRecorder();
      } else {
          startRecorder();
      }
  }

  const startRecorder = () => {
      recorderControls.startRecording();
      setIsRecordingSample(true);
    };
  
  const stopRecorder = () => {
      recorderControls.stopRecording();
      setIsRecordingSample(false);
  };

  const doneOrSkipRecorder = async () => {
    setIsRecordViewShown(false);
    if(wavBlobOfRecord) {
      //done
      if(sampleFileName !== '') {
        const deleteSet = 'smaple';   //'all','smaple','clone'
        setIsLoading(true);
        await handleClearFileFromserver(deleteSet);
        setSampleFileName('');
        setIsLoading(false);
      }
    } else {
      //skip
    }
  };

  //save .wav file
  const saveRecordingWavBlob = async (blob) => {
    if (blob) {
      // Convert the audio blob to an AudioBuffer
      const arrayBuffer = await blob.arrayBuffer();
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

      // Create an OfflineAudioContext with the desired output sample rate
      const offlineCtx = new OfflineAudioContext(audioBuffer.numberOfChannels, audioBuffer.duration * 48000, 48000);

      // Create a buffer source
      const bufferSource = offlineCtx.createBufferSource();
      bufferSource.buffer = audioBuffer;

      // Connect the source to the context
      bufferSource.connect(offlineCtx.destination);

      // Start the source
      bufferSource.start();

      // Render the audio and get the resulting buffer
      const resampledBuffer = await offlineCtx.startRendering();

      // Check the duration of the audio
      const duration = resampledBuffer.duration;

      // Convert the resampled audio buffer to WAV
      const wav = toWav(resampledBuffer, 1 );

      // Create a new blob from the WAV file
      const wavBlobTT = new Blob([new DataView(wav)], { type: 'audio/wav' });
      setWavBlobOfRecord(wavBlobTT);
      setIsConvertDone(false);
      // onSaveAudio(wavBlob, duration); 

      // // Create a URL for the blob
      // const url = URL.createObjectURL(wavBlob);
      // setBlobURL(url);

      // // Create a URL for the blob
      // const link = document.createElement('a');
      // link.href = url;
      // link.download = 'signature.wav'; // Custom filename
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      // URL.revokeObjectURL(url); // Clean up
    } else {
      setWavBlobOfRecord(null);
      console.log('No audio to save');
    }
  };

  //——————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  //2024.06.07 select audio function pre upload

  const handleFileSelect = async (e) => {
    e.preventDefault();
    if (isRecordingSample) {
      return;
    }
    const file = e.target.files[0];
    if (!file) return;
    preCheckAudioFile(file);
  };
  
  const preCheckAudioFile = async (file) => {

    let waveBufferTemp = file;
    let audioChannels = await getAudioChannels(file);
    if (file.type === "audio/mp3" || file.type === "audio/mpeg" || audioChannels > 1) {
      waveBufferTemp = await convertMp3ToWavBuffer(file);
      setError(null);
      const blob = new Blob([waveBufferTemp], { type: 'audio/wav' });
      setWavBlobOfRecord(blob);
    } else if (file.type === "audio/wav") {
      const blob = new Blob([waveBufferTemp], { type: 'audio/wav' });
      setWavBlobOfRecord(blob);
      setError(null);
    } else {
      console.error("Unsupported file type");
      setWavBlobOfRecord(null);
    }
  };

  const convertMp3ToWavBuffer = async (mp3blob) => {
    if (!mp3blob) {
      setError("File format error. Please upload a valid audio file.");
      return null;
    }
    const arrayBuffer = await mp3blob.arrayBuffer();
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const originalBuffer = await audioContext.decodeAudioData(arrayBuffer);
  
    let audioChannels = await getAudioChannels(mp3blob);
    if (audioChannels === 1) {
      const wavArrayBuffer = toWav(originalBuffer, 48000);
      const buffer = Buffer.from(wavArrayBuffer);
      return buffer;
    }
    // 创建一个新的单声道 AudioBuffer 对象
    const monoBuffer = audioContext.createBuffer(1, originalBuffer.length, originalBuffer.sampleRate);
  
    // 将原音频数据的左声道复制到新的 AudioBuffer 对象中
    const originalData = originalBuffer.getChannelData(0);
    const monoData = monoBuffer.getChannelData(0);
    for (let i = 0; i < originalBuffer.length; i++) {
      monoData[i] = originalData[i];
    }
  
    const wavArrayBuffer = toWav(monoBuffer, 48000);
    const buffer = Buffer.from(wavArrayBuffer);
  
    return buffer;
  };
  //——————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  //clone audio from AI without sample audio
  const saveRecording = async (mp3blob) => {
    if (mp3blob) {
      // Convert the audio blob to an AudioBuffer
      const arrayBuffer = await mp3blob.arrayBuffer();
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
      setDuration(audioBuffer.duration);

      // Custom sample rate here: VIP set
      const wav = toWav(audioBuffer,48000);

      // Create a new blob from the WAV file
      wavBlob = new Blob([new DataView(wav)], { type: 'audio/wav' });
  
      // Create a URL for the blob
      // const url = URL.createObjectURL(wavBlob);
      // const link = document.createElement('a');
      // link.href = url;
      // const preName = 'Clone';
      // link.download = `${nameSetbyTime(preName)}.wav`; // Custom filename
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      // URL.revokeObjectURL(url); // Clean up
      // Create a URL for the blob
    const url = URL.createObjectURL(wavBlob);
    ttsOutputRef.current.src = url;
    const preName = 'Clone';
    const filename = `${nameSetbyTime(preName)}.wav`; // Custom filename

    // Save the filename for later use
    if (sampleFileName ==='') setCloneFileName(filename);
    setIsLoading(false);
    }
  };

  const nameSetbyTime = (preName) => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based in JavaScript
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    const filename = `${preName}_${year}${month}${day}_${hour}${minute}`;
    return filename;
  };

  function handleClose () {
    if(sampleFileName !== '') {
      const deleteSet = 'all';   //'all','smaple','clone'
      handleClearFileFromserver(deleteSet);
    }
    setIsVisibleTTS(false);
    onClose();
  }

  function recordOrSlectSampleVoice() {
    setIsRecordViewShown(true);
  }

  return (

    <div className={`popup-background-FAQs ${isVisibleTTS ? 'active' : ''}`}>
      <div className='popup-FAQs'>
        <div className='header-FAQs'>
          <h1 className='h1-FAQs'>Text To Speech</h1>
          {/* <Button  
            onClick={recordOrSlectSampleVoice} 
            className="appstyle-btn-outline">
            <span className="btn-text"> New Voice Sample </span>
          </Button> */}
          <span className="close-FAQs" onClick={handleClose}>&times;</span>
        </div>

        <div className="content-TTS-body">
          {isRecordViewShown && 
            <div className="popup-tts-recorder-container">
              <AudioRecorder
                onRecordingComplete={(blob) => addAudioElement(blob)}
                recorderControls={recorderControls}
                downloadOnSavePress={false}
                downloadFileExtension="wav"
                showVisualizer={true}
              />
              <p className="wavrecorder-p">Record or select a sample of the sound you want to clone. About 10 seconds is enough.</p>
              <p className="wavrecorder-p">OR</p>
              <button  
                onClick={() => document.getElementById('fileInput').click()} 
                className="appstyle-btn-outline-gray-tts" disabled={isRecordingSample}>
                <span className="btn-text"> Browse files </span>
              </button>
              <input style={{display: 'none'}} type="file" multiple accept="audio/*" id="fileInput" onChange={handleFileSelect} />
              <div className='wavrecorder-btn-container'>
                <button className="wavrecorder_btn" 
                    onClick={handleRecordBtnClick} >
                    {isRecordingSample 
                      ? 'Stop'
                      : 'Start'
                    }
                </button>
                <button className="wavrecorder_btn" onClick={doneOrSkipRecorder} disabled={isRecordingSample}>
                    {wavBlobOfRecord !== null ? 'Done' : 'Skip'} 
                </button>
              </div> 
            </div>}

          {error && <p style={{animation: 'blink 0.7s infinite', fontSize: '14px', marginTop:'-20px', marginBottom:'-20px'}}>{error}</p>}
          {!isRecordViewShown && 
            <textarea value={text} onChange={handleTextChange} placeholder="Enter text here..." className="Form-control-TTS">
            </textarea>
          }
           
          {!isRecordViewShown && 
            <div style={{ display: 'flex', justifyContent: 'center', alignItems:'center', width: '100%', gap:'30px' }}> 
              
              <button onClick={handleClone} disabled={isLoading || text === '' || isConvertDone} 
                  className={`appstyle-btn ${(isLoading || text === '' || isConvertDone) ? "appstyle-btngray" : ""}`}  
                  style={{height:'fit-content', width:'fit-content', cursor: (isLoading || text === '' || isConvertDone) ? "not-allowed" : "pointer", padding:'5px 15px'}}>
                  {isLoading ? <span>Converting<span className="dots"> </span></span> : 'Convert to Audio'}
                </button>
              <audio ref={ttsOutputRef} controls src="tts_output.wav" 
                style={{ display: (cloneFileName !== '' && !isLoading) ? 'block':'none', width: '40%', height:'100%' }}></audio>
              {cloneFileName !== '' && !isLoading && 
                <button onClick={donwloadClick} 
                  disabled={!cloneFileName || text === '' || isRecordViewShown} className={`appstyle-btn ${(isLoading || text === '') ? "appstyle-btngray" : ""}`}  
                  style={{height:'fit-content', width:'fit-content', cursor: (isLoading || text === '') ? "not-allowed" : "pointer", padding:'5px 15px'}}>
                    <span>Download</span> 
                </button>}
            </div>}
        </div>
      </div>
    </div>
  );
};

export default TextToSpeech;

const getAudioChannels = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = function(ev) {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      audioContext.decodeAudioData(ev.target.result, function(buffer) {
        resolve(buffer.numberOfChannels);
      });
    };
    reader.readAsArrayBuffer(file);
  });
};
